/* 
Displays ENS info instead of an Eth address if it exists
*/
import { Text } from "@mantine/core";
import "./address.css";

export default function NickName(props) {
  // Function to select a Transcoder, if it is passed
  const selectTranscoder = async () => {
    if (props.selectTranscoder) {
      props.selectTranscoder(props.address);
    }
  };

  return (
    <Text
      sx={{
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
      }}
      onClick={selectTranscoder}
      className={[
        props.selectTranscoder && "hoverAddress",
        props.emphasize && "emphasized",
      ]}
    >
      {props.nickname}
    </Text>
  );
}
